import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-order-progress-bar',
  templateUrl: './order-progress-bar.component.html',
  styleUrls: ['./order-progress-bar.component.scss']
})
export class OrderProgressBarComponent {
  @Input() maxWebStatus = 0;
  @Input() webStatusCount = 0;
  @Input() currentStatusLabel = '';

  readonly steps = ['Confirmed', 'In Production', 'Build Complete', 'Shipped', 'Delivered'];

  getStepClass(segmentNumber: number): string {
    const s = parseInt(String(this.maxWebStatus), 10) || 0;
    // Segment numbers are 1-based (1=Confirmed through 5=Delivered)
    const seg = segmentNumber + 1;
    if (seg === 5 && seg === s) return 'segment completed';
    if (seg === s) return 'segment active';
    if (seg < s) return 'segment completed';
    return 'segment';
  }
}
